import { Drawer } from 'antd';
import Style from './assets/style.scss';
import { IDrawerProps } from './entities';

const BCDrawer = (props: IDrawerProps) => {
	return (
		<Drawer
			{...props}
			rootClassName={[Style.BCDrawer, props.className].join(' ')}
		/>
	);
};
export default BCDrawer;
export { IDrawerProps };
